export default __webpack_public_path__ + "static/media/MRT.753b5c51.svg";